<template>
  <div>
    <z-modal
      :show="show"
      centered
      size="md"
      body-class="p-0 rounded"
      @hide="hideModal"
    >
      <form-create-client
        @close="hideModal"
        @branch-created="handleBranchCreated"
      />
    </z-modal>
  </div>
</template>

<script>
import ZModal from "@zubut/common/src/components/ZModal";
import FormCreateClient from "./FormCreateClient";
import * as mutation from "@/store/modules/branch/mutations-types";

export default {
  name: "ClientCreateBranchDesktop",

  components: {
    ZModal,
    FormCreateClient
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    parentCompany: {
      type: String,
      required: true
    }
  },

  watch: {
    show(newVal) {
      if (newVal) {
        this.$store.commit(
          `branch/${mutation.SET_PARENT_COMPANY}`,
          this.parentCompany
        );
      }
    }
  },

  methods: {
    hideModal() {
      this.$emit("update:show", false);
    },
    handleBranchCreated(client) {
      this.$emit("branch-created", client);
    }
  }
};
</script>

<style lang="scss" scoped></style>
